import api from './axios';

export const createRequest = (data) =>
  api.post('/service-requests', data).then((r) => r.data.data);

export const getMyRequests = (params) =>
  api.get('/service-requests/my/requests', { params }).then((r) => r.data.data);

export const trackRequest = (trackingId) =>
  api.get(`/service-requests/track/${trackingId}`).then((r) => r.data.data);
